export enum PlanwertStatus {
    OPEN = 'OPEN',
    PROCESSED = 'PROCESSED',
    INVALID = 'INVALID',
    SYSTEM_FAILED = 'SYSTEM_FAILED'
}

export class PlanwertStatusItem {

    public key: PlanwertStatus;
    public description: string;

    constructor(key: PlanwertStatus, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): PlanwertStatusItem[] {
        return [
            new PlanwertStatusItem(PlanwertStatus.OPEN, this.getLabelByStatusEnum(PlanwertStatus.OPEN)),
            new PlanwertStatusItem(PlanwertStatus.PROCESSED, this.getLabelByStatusEnum(PlanwertStatus.PROCESSED)),
            new PlanwertStatusItem(PlanwertStatus.INVALID, this.getLabelByStatusEnum(PlanwertStatus.INVALID)),
            new PlanwertStatusItem(PlanwertStatus.SYSTEM_FAILED, this.getLabelByStatusEnum(PlanwertStatus.SYSTEM_FAILED)),
        ];
    }

    public static getStatusEnumByLabel(label: string): PlanwertStatus {
        if (!label) {
            return;
        }
        switch (label) {
            case 'Offen': return PlanwertStatus.OPEN;
            case 'Übernommen': return PlanwertStatus.PROCESSED;
            case 'Ungültig': return PlanwertStatus.INVALID;
            case 'Systemfehler': return PlanwertStatus.SYSTEM_FAILED;
            default:
                throw new Error(`Can not map label to status, because of invalid argument (${label}).`);
        }
    }

    public static getLabelByStatusEnum(statusEnum: PlanwertStatus): string {
        if (!statusEnum) {
            return;
        }
        switch (statusEnum) {
            case PlanwertStatus.OPEN: return 'Offen';
            case PlanwertStatus.PROCESSED: return 'Übernommen';
            case PlanwertStatus.INVALID: return 'Ungültig';
            case PlanwertStatus.SYSTEM_FAILED: return 'Systemfehler';
            default:
                throw new Error(`Can not map status to label, because of invalid argument (${statusEnum}).`);
        }
    }

}
